// Automatically generated with Reach 0.1.8 (dab71275)
/* eslint-disable */
export const _version = '0.1.8';
export const _versionHash = '0.1.8 (dab71275)';
export const _backendVersion = 7;

export function getExports(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getEvents(s) {
  const stdlib = s.reachStdlib;
  return {
    };
  };
export function _getViews(s, viewlib) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Bool;
  
  return {
    infos: {
      Auction: {
        bids: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        closed: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              return (await ((async () => {
                
                
                return true;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              return (await ((async () => {
                
                
                return true;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              return (await ((async () => {
                
                
                return false;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc3
          },
        closes: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        currentPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              return (await ((async () => {
                
                
                return v962;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              return (await ((async () => {
                
                
                return v962;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              return (await ((async () => {
                
                
                return v962;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        endCTime: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        endSecs: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              return (await ((async () => {
                
                
                return v963;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              return (await ((async () => {
                
                
                return v963;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              return (await ((async () => {
                
                
                return v963;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        highestBidder: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              return (await ((async () => {
                
                
                return v964;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              return (await ((async () => {
                
                
                return v964;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              return (await ((async () => {
                
                
                return v964;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc0
          },
        lastCTime: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              stdlib.assert(false, 'illegal view')
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        minBid: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              return (await ((async () => {
                
                
                return v1802;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              return (await ((async () => {
                
                
                return v1802;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              return (await ((async () => {
                
                
                return v994;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        owner: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              return (await ((async () => {
                
                
                return v915;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              return (await ((async () => {
                
                
                return v915;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              return (await ((async () => {
                
                
                return v915;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc0
          },
        recvAddr: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              return (await ((async () => {
                
                
                return v916;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              return (await ((async () => {
                
                
                return v916;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              return (await ((async () => {
                
                
                return v916;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc0
          },
        reservePrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              return (await ((async () => {
                
                
                return v919;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              return (await ((async () => {
                
                
                return v919;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              return (await ((async () => {
                
                
                return v919;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        royalties: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              return (await ((async () => {
                
                
                return v918;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              return (await ((async () => {
                
                
                return v918;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              return (await ((async () => {
                
                
                return v918;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        startPrice: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              return (await ((async () => {
                
                
                return v920;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              return (await ((async () => {
                
                
                return v920;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              return (await ((async () => {
                
                
                return v920;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc1
          },
        token: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              return (await ((async () => {
                
                
                return v925;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              return (await ((async () => {
                
                
                return v925;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              return (await ((async () => {
                
                
                return v925;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc2
          },
        tokenP: {
          decode: async (i, svs, args) => {
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 1))) {
              const [v880, v881, v882, v883, v887] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 2))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951] = svs;
              stdlib.assert(false, 'illegal view')
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 4))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815] = svs;
              return (await ((async () => {
                
                
                return v926;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 7))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875] = svs;
              return (await ((async () => {
                
                
                return v926;}))(...args));
              }
            if (stdlib.eq(i, stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10))) {
              const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = svs;
              return (await ((async () => {
                
                
                return v926;}))(...args));
              }
            
            stdlib.assert(false, 'illegal view')
            },
          ty: ctc2
          }
        }
      },
    views: {
      1: [ctc0, ctc0, ctc0, ctc0, ctc0],
      2: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0],
      4: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc3, ctc1],
      7: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc3, ctc1, ctc1],
      10: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]
      }
    };
  
  };
export function _getMaps(s) {
  const stdlib = s.reachStdlib;
  const ctc0 = stdlib.T_Tuple([]);
  return {
    mapDataTy: ctc0
    };
  };
export async function Auctioneer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Auctioneer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Object({
    bidIncrementAbs: ctc1,
    bidIncrementRel: ctc1,
    deadline: ctc1,
    deadlineSecs: ctc1,
    deadlineStep: ctc1,
    maxDeadline: ctc1,
    recvAddr: ctc0,
    reservePrice: ctc1,
    royaltyAddr: ctc0,
    royaltyCents: ctc1,
    startPrice: ctc1,
    token: ctc2,
    tokenP: ctc2,
    unitAmount: ctc1
    });
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Tuple([ctc1]);
  const ctc7 = stdlib.T_Data({
    Bid_claim0_160: ctc5,
    Bid_close0_160: ctc5,
    Bid_getBid0_160: ctc6,
    Bid_getPurchase0_160: ctc6,
    Bid_touch0_160: ctc5
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v880, v881, v882, v883], secs: v885, time: v884, didSend: v36, from: v879 } = txn1;
  ;
  const v887 = v883;
  const v893 = stdlib.protect(ctc3, await interact.getParams(), {
    at: './donate.rsh:100:38:application',
    fs: ['at ./donate.rsh:83:18:application call to [unknown function] (defined at: ./donate.rsh:83:22:function exp)'],
    msg: 'getParams',
    who: 'Auctioneer'
    });
  const v894 = v893.recvAddr;
  const v895 = v893.royaltyAddr;
  const v896 = v893.royaltyCents;
  const v897 = v893.token;
  const v898 = v893.tokenP;
  const v899 = v893.reservePrice;
  const v900 = v893.startPrice;
  const v901 = v893.bidIncrementAbs;
  const v902 = v893.bidIncrementRel;
  const v903 = v893.deadline;
  const v904 = v893.maxDeadline;
  const v905 = v893.unitAmount;
  const v906 = v893.deadlineStep;
  const v907 = v893.deadlineSecs;
  const v908 = stdlib.tokenEq(v897, v898);
  const v909 = v908 ? false : true;
  stdlib.assert(v909, {
    at: './donate.rsh:101:11:application',
    fs: ['at ./donate.rsh:83:18:application call to [unknown function] (defined at: ./donate.rsh:83:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v910 = stdlib.ge(v896, stdlib.checkedBigNumberify('./donate.rsh:102:28:decimal', stdlib.UInt_max, 0));
  const v911 = stdlib.le(v896, stdlib.checkedBigNumberify('./donate.rsh:102:49:decimal', stdlib.UInt_max, 99));
  const v912 = v910 ? v911 : false;
  stdlib.assert(v912, {
    at: './donate.rsh:102:11:application',
    fs: ['at ./donate.rsh:83:18:application call to [unknown function] (defined at: ./donate.rsh:83:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v913 = stdlib.ge(v900, stdlib.checkedBigNumberify('./donate.rsh:103:26:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v913, {
    at: './donate.rsh:103:11:application',
    fs: ['at ./donate.rsh:83:18:application call to [unknown function] (defined at: ./donate.rsh:83:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  const v914 = stdlib.lt(v900, v899);
  stdlib.assert(v914, {
    at: './donate.rsh:104:11:application',
    fs: ['at ./donate.rsh:83:18:application call to [unknown function] (defined at: ./donate.rsh:83:22:function exp)'],
    msg: null,
    who: 'Auctioneer'
    });
  
  const txn2 = await (ctc.sendrecv({
    args: [v880, v881, v882, v883, v887, v894, v895, v896, v899, v900, v901, v902, v903, v904, v897, v898, v905, v906, v907],
    evt_cnt: 14,
    funcNum: 1,
    lct: v884,
    onlyIf: true,
    out_tys: [ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:124:11:decimal', stdlib.UInt_max, 100000), []],
    sim_p: (async (txn2) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v916, v917, v918, v919, v920, v921, v922, v923, v924, v925, v926, v927, v928, v929], secs: v931, time: v930, didSend: v89, from: v915 } = txn2;
      
      const v932 = stdlib.tokenEq(v925, v926);
      const v933 = v932 ? false : true;
      stdlib.assert(v933, {
        at: './donate.rsh:107:6:dot',
        fs: [],
        msg: 'non-network tokens distinct',
        who: 'Auctioneer'
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
        kind: 'init',
        tok: v925
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
        kind: 'init',
        tok: v926
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./donate.rsh:124:11:decimal', stdlib.UInt_max, 100000),
        kind: 'to',
        tok: undefined
        });
      stdlib.assert(v933, {
        at: './donate.rsh:125:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v938 = stdlib.ge(v918, stdlib.checkedBigNumberify('./donate.rsh:126:27:decimal', stdlib.UInt_max, 0));
      const v939 = stdlib.le(v918, stdlib.checkedBigNumberify('./donate.rsh:126:48:decimal', stdlib.UInt_max, 99));
      const v940 = v938 ? v939 : false;
      stdlib.assert(v940, {
        at: './donate.rsh:126:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v941 = stdlib.ge(v920, stdlib.checkedBigNumberify('./donate.rsh:127:25:decimal', stdlib.UInt_max, 0));
      stdlib.assert(v941, {
        at: './donate.rsh:127:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v942 = stdlib.lt(v920, v919);
      stdlib.assert(v942, {
        at: './donate.rsh:128:10:application',
        fs: [],
        msg: null,
        who: 'Auctioneer'
        });
      const v946 = stdlib.sub(stdlib.checkedBigNumberify('./donate.rsh:124:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./donate.rsh:131:12:decimal', stdlib.UInt_max, 20000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./donate.rsh:131:12:decimal', stdlib.UInt_max, 20000),
        kind: 'from',
        to: v880,
        tok: undefined
        });
      const v950 = stdlib.sub(v946, stdlib.checkedBigNumberify('./donate.rsh:132:12:decimal', stdlib.UInt_max, 80000));
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./donate.rsh:132:12:decimal', stdlib.UInt_max, 80000),
        kind: 'from',
        to: v882,
        tok: undefined
        });
      const v951 = v915;
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    waitIfNotPresent: false
    }));
  const {data: [v916, v917, v918, v919, v920, v921, v922, v923, v924, v925, v926, v927, v928, v929], secs: v931, time: v930, didSend: v89, from: v915 } = txn2;
  const v932 = stdlib.tokenEq(v925, v926);
  const v933 = v932 ? false : true;
  stdlib.assert(v933, {
    at: './donate.rsh:107:6:dot',
    fs: [],
    msg: 'non-network tokens distinct',
    who: 'Auctioneer'
    });
  ;
  ;
  ;
  stdlib.assert(v933, {
    at: './donate.rsh:125:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v938 = stdlib.ge(v918, stdlib.checkedBigNumberify('./donate.rsh:126:27:decimal', stdlib.UInt_max, 0));
  const v939 = stdlib.le(v918, stdlib.checkedBigNumberify('./donate.rsh:126:48:decimal', stdlib.UInt_max, 99));
  const v940 = v938 ? v939 : false;
  stdlib.assert(v940, {
    at: './donate.rsh:126:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v941 = stdlib.ge(v920, stdlib.checkedBigNumberify('./donate.rsh:127:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v941, {
    at: './donate.rsh:127:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v942 = stdlib.lt(v920, v919);
  stdlib.assert(v942, {
    at: './donate.rsh:128:10:application',
    fs: [],
    msg: null,
    who: 'Auctioneer'
    });
  const v946 = stdlib.sub(stdlib.checkedBigNumberify('./donate.rsh:124:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./donate.rsh:131:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v950 = stdlib.sub(v946, stdlib.checkedBigNumberify('./donate.rsh:132:12:decimal', stdlib.UInt_max, 80000));
  ;
  const v951 = v915;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v954, time: v953, didSend: v114, from: v952 } = txn3;
  ;
  ;
  const v958 = stdlib.addressEq(v951, v952);
  stdlib.assert(v958, {
    at: './donate.rsh:138:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Auctioneer'
    });
  const v961 = 'Start Auction';
  stdlib.protect(ctc4, await interact.log(v961), {
    at: './donate.rsh:142:40:application',
    fs: ['at ./donate.rsh:142:7:application call to [unknown function] (defined at: ./donate.rsh:142:25:function exp)'],
    msg: 'log',
    who: 'Auctioneer'
    });
  
  let v962 = stdlib.checkedBigNumberify('./donate.rsh:174:24:decimal', stdlib.UInt_max, 0);
  let v963 = v929;
  let v964 = v915;
  let v965 = true;
  let v966 = v953;
  let v969 = v954;
  let v972 = v950;
  let v973 = stdlib.checkedBigNumberify('./donate.rsh:138:15:decimal', stdlib.UInt_max, 1);
  let v974 = stdlib.checkedBigNumberify('./donate.rsh:107:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v965;})()) {
    const v989 = stdlib.add(v962, v921);
    const v990 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v991 = stdlib.mul(v990, v922);
    const v992 = stdlib.add(v962, v991);
    const v993 = stdlib.gt(v989, v992);
    const v994 = v993 ? v989 : v992;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc7],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn4;
    switch (v1109[0]) {
      case 'Bid_claim0_160': {
        const v1112 = v1109[1];
        ;
        ;
        undefined;
        const v1169 = stdlib.addressEq(v1108, v916);
        const v1170 = stdlib.ge(v962, v919);
        const v1171 = v1169 ? v1170 : false;
        stdlib.assert(v1171, {
          at: './donate.rsh:263:18:application',
          fs: ['at ./donate.rsh:262:9:application call to [unknown function] (defined at: ./donate.rsh:262:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v1176 = stdlib.sub(v973, v973);
        ;
        const v1177 = null;
        await txn4.getOutput('Bid_claim', 'v1177', ctc4, v1177);
        const cv962 = v962;
        const cv963 = v963;
        const cv964 = v964;
        const cv965 = false;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v1176;
        const cv974 = v974;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_close0_160': {
        const v1249 = v1109[1];
        ;
        ;
        undefined;
        const v1323 = null;
        await txn4.getOutput('Bid_close', 'v1323', ctc4, v1323);
        const v1330 = stdlib.lt(v969, v963);
        const cv962 = v962;
        const cv963 = v963;
        const cv964 = v964;
        const cv965 = v1330;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v974;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_getBid0_160': {
        const v1386 = v1109[1];
        const v1407 = v1386[stdlib.checkedBigNumberify('./donate.rsh:206:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1440 = stdlib.add(v974, v1407);
        ;
        undefined;
        const v1472 = stdlib.lt(v969, v963);
        const v1479 = stdlib.ge(v1407, v994);
        const v1480 = v1472 ? v1479 : false;
        const v1481 = stdlib.ge(v1407, v920);
        const v1482 = v1480 ? v1481 : false;
        stdlib.assert(v1482, {
          at: './donate.rsh:213:18:application',
          fs: ['at ./donate.rsh:212:9:application call to [unknown function] (defined at: ./donate.rsh:212:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v1486 = stdlib.sub(v1440, v962);
        ;
        const v1487 = null;
        await txn4.getOutput('Bid_getBid', 'v1487', ctc4, v1487);
        const v1493 = stdlib.add(v963, stdlib.checkedBigNumberify('./donate.rsh:162:33:decimal', stdlib.UInt_max, 60));
        const cv962 = v1407;
        const cv963 = v1493;
        const cv964 = v1108;
        const cv965 = true;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v1486;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0_160': {
        const v1523 = v1109[1];
        const v1552 = v1523[stdlib.checkedBigNumberify('./donate.rsh:231:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1577 = stdlib.add(v974, v1552);
        ;
        undefined;
        const v1635 = stdlib.ge(v969, v963);
        const v1636 = stdlib.lt(v962, v919);
        const v1637 = v1635 ? v1636 : false;
        const v1638 = stdlib.ge(v1552, v919);
        const v1639 = v1637 ? v1638 : false;
        stdlib.assert(v1639, {
          at: './donate.rsh:239:18:application',
          fs: ['at ./donate.rsh:238:9:application call to [unknown function] (defined at: ./donate.rsh:238:9:function exp)'],
          msg: null,
          who: 'Auctioneer'
          });
        const v1643 = stdlib.sub(v1577, v962);
        ;
        const v1644 = null;
        await txn4.getOutput('Bid_getPurchase', 'v1644', ctc4, v1644);
        const cv962 = v1552;
        const cv963 = v963;
        const cv964 = v1108;
        const cv965 = false;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v1643;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_touch0_160': {
        const v1660 = v1109[1];
        ;
        ;
        undefined;
        const v1790 = null;
        await txn4.getOutput('Bid_touch', 'v1790', ctc4, v1790);
        const cv962 = v962;
        const cv963 = v963;
        const cv964 = v964;
        const cv965 = true;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v974;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      }
    
    }
  const v1797 = stdlib.add(v962, v921);
  const v1798 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1799 = stdlib.mul(v1798, v922);
  const v1800 = stdlib.add(v962, v1799);
  const v1801 = stdlib.gt(v1797, v1800);
  const v1802 = v1801 ? v1797 : v1800;
  const v1804 = stdlib.div(v974, stdlib.checkedBigNumberify('./donate.rsh:299:34:decimal', stdlib.UInt_max, 100));
  const v1805 = stdlib.mul(v918, v1804);
  const v1807 = stdlib.add(v1805, v1804);
  const v1808 = stdlib.sub(v974, v1807);
  const v1809 = stdlib.ge(v962, v919);
  const v1810 = stdlib.add(v1808, v1805);
  const v1811 = stdlib.add(v1810, v1804);
  const v1815 = stdlib.sub(v974, v1811);
  ;
  if (v1809) {
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1819, time: v1818, didSend: v833, from: v1817 } = txn4;
    ;
    const v1821 = stdlib.addressEq(v887, v1817);
    stdlib.assert(v1821, {
      at: './donate.rsh:335:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Auctioneer'
      });
    if (v1809) {
      const v1826 = stdlib.sub(v973, v973);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1875 = stdlib.sub(v973, v973);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1879, time: v1878, didSend: v833, from: v1877 } = txn4;
    ;
    const v1881 = stdlib.addressEq(v887, v1877);
    stdlib.assert(v1881, {
      at: './donate.rsh:335:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Auctioneer'
      });
    if (v1809) {
      const v1886 = stdlib.sub(v1875, v1875);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
export async function Bid_claim(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_claim expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_claim expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0_160: ctc4,
    Bid_close0_160: ctc4,
    Bid_getBid0_160: ctc5,
    Bid_getPurchase0_160: ctc5,
    Bid_touch0_160: ctc4
    });
  
  
  const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v1035 = ctc.selfAddress();
  const v1037 = stdlib.protect(ctc4, await interact.in(), {
    at: './donate.rsh:1:23:application',
    fs: ['at ./donate.rsh:258:9:application call to [unknown function] (defined at: ./donate.rsh:258:9:function exp)', 'at ./donate.rsh:171:19:application call to "runBid_claim0_160" (defined at: ./donate.rsh:257:11:function exp)', 'at ./donate.rsh:171:19:application call to [unknown function] (defined at: ./donate.rsh:171:19:function exp)'],
    msg: 'in',
    who: 'Bid_claim'
    });
  const v1039 = stdlib.addressEq(v1035, v916);
  const v1040 = stdlib.ge(v962, v919);
  const v1041 = v1039 ? v1040 : false;
  stdlib.assert(v1041, {
    at: './donate.rsh:258:23:application',
    fs: ['at ./donate.rsh:258:9:application call to [unknown function] (defined at: ./donate.rsh:258:14:function exp)', 'at ./donate.rsh:258:9:application call to [unknown function] (defined at: ./donate.rsh:258:9:function exp)', 'at ./donate.rsh:171:19:application call to "runBid_claim0_160" (defined at: ./donate.rsh:257:11:function exp)', 'at ./donate.rsh:171:19:application call to [unknown function] (defined at: ./donate.rsh:171:19:function exp)'],
    msg: null,
    who: 'Bid_claim'
    });
  
  const v1053 = ['Bid_claim0_160', v1037];
  
  const txn1 = await (ctc.sendrecv({
    args: [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994, v1053],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:261:18:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./donate.rsh:261:22:decimal', stdlib.UInt_max, 0), v926]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn1;
      
      switch (v1109[0]) {
        case 'Bid_claim0_160': {
          const v1112 = v1109[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:261:18:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:261:22:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v926
            });
          undefined;
          const v1169 = stdlib.addressEq(v1108, v916);
          const v1171 = v1169 ? v1040 : false;
          stdlib.assert(v1171, {
            at: './donate.rsh:263:18:application',
            fs: ['at ./donate.rsh:262:9:application call to [unknown function] (defined at: ./donate.rsh:262:9:function exp)'],
            msg: null,
            who: 'Bid_claim'
            });
          const v1176 = stdlib.sub(v973, v973);
          sim_r.txns.push({
            amt: v973,
            kind: 'from',
            to: v916,
            tok: v925
            });
          const v1177 = null;
          const v1178 = await txn1.getOutput('Bid_claim', 'v1177', ctc3, v1177);
          
          const v3231 = v962;
          const v3232 = v963;
          const v3233 = v964;
          const v3237 = v972;
          const v3238 = v1176;
          const v3246 = stdlib.add(v962, v921);
          const v3247 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v3248 = stdlib.mul(v3247, v922);
          const v3249 = stdlib.add(v962, v3248);
          const v3250 = stdlib.gt(v3246, v3249);
          const v3251 = v3250 ? v3246 : v3249;
          const v3252 = stdlib.div(v974, stdlib.checkedBigNumberify('./donate.rsh:299:34:decimal', stdlib.UInt_max, 100));
          const v3253 = stdlib.mul(v918, v3252);
          const v3254 = stdlib.add(v3253, v3252);
          const v3255 = stdlib.sub(v974, v3254);
          const v3257 = stdlib.add(v3255, v3253);
          const v3258 = stdlib.add(v3257, v3252);
          const v3259 = stdlib.sub(v974, v3258);
          sim_r.txns.push({
            amt: v3258,
            kind: 'from',
            to: v964,
            tok: v926
            });
          if (v1040) {
            sim_r.isHalt = false;
            }
          else {
            const v3266 = stdlib.sub(v1176, v1176);
            sim_r.txns.push({
              amt: v1176,
              kind: 'from',
              to: v915,
              tok: v925
              });
            sim_r.isHalt = false;
            }
          break;
          }
        case 'Bid_close0_160': {
          const v1249 = v1109[1];
          
          break;
          }
        case 'Bid_getBid0_160': {
          const v1386 = v1109[1];
          
          break;
          }
        case 'Bid_getPurchase0_160': {
          const v1523 = v1109[1];
          
          break;
          }
        case 'Bid_touch0_160': {
          const v1660 = v1109[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn1;
  switch (v1109[0]) {
    case 'Bid_claim0_160': {
      const v1112 = v1109[1];
      ;
      ;
      undefined;
      const v1169 = stdlib.addressEq(v1108, v916);
      const v1171 = v1169 ? v1040 : false;
      stdlib.assert(v1171, {
        at: './donate.rsh:263:18:application',
        fs: ['at ./donate.rsh:262:9:application call to [unknown function] (defined at: ./donate.rsh:262:9:function exp)'],
        msg: null,
        who: 'Bid_claim'
        });
      const v1176 = stdlib.sub(v973, v973);
      ;
      const v1177 = null;
      const v1178 = await txn1.getOutput('Bid_claim', 'v1177', ctc3, v1177);
      if (v705) {
        stdlib.protect(ctc3, await interact.out(v1112, v1178), {
          at: './donate.rsh:257:12:application',
          fs: ['at ./donate.rsh:257:12:application call to [unknown function] (defined at: ./donate.rsh:257:12:function exp)', 'at ./donate.rsh:267:12:application call to "k" (defined at: ./donate.rsh:262:9:function exp)', 'at ./donate.rsh:262:9:application call to [unknown function] (defined at: ./donate.rsh:262:9:function exp)'],
          msg: 'out',
          who: 'Bid_claim'
          });
        }
      else {
        }
      
      const v3231 = v962;
      const v3232 = v963;
      const v3233 = v964;
      const v3237 = v972;
      const v3238 = v1176;
      const v3246 = stdlib.add(v962, v921);
      const v3247 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v3248 = stdlib.mul(v3247, v922);
      const v3249 = stdlib.add(v962, v3248);
      const v3250 = stdlib.gt(v3246, v3249);
      const v3251 = v3250 ? v3246 : v3249;
      const v3252 = stdlib.div(v974, stdlib.checkedBigNumberify('./donate.rsh:299:34:decimal', stdlib.UInt_max, 100));
      const v3253 = stdlib.mul(v918, v3252);
      const v3254 = stdlib.add(v3253, v3252);
      const v3255 = stdlib.sub(v974, v3254);
      const v3257 = stdlib.add(v3255, v3253);
      const v3258 = stdlib.add(v3257, v3252);
      const v3259 = stdlib.sub(v974, v3258);
      ;
      if (v1040) {
        return;
        }
      else {
        const v3266 = stdlib.sub(v1176, v1176);
        ;
        return;
        }
      break;
      }
    case 'Bid_close0_160': {
      const v1249 = v1109[1];
      return;
      break;
      }
    case 'Bid_getBid0_160': {
      const v1386 = v1109[1];
      return;
      break;
      }
    case 'Bid_getPurchase0_160': {
      const v1523 = v1109[1];
      return;
      break;
      }
    case 'Bid_touch0_160': {
      const v1660 = v1109[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_close(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_close expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_close expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0_160: ctc4,
    Bid_close0_160: ctc4,
    Bid_getBid0_160: ctc5,
    Bid_getPurchase0_160: ctc5,
    Bid_touch0_160: ctc4
    });
  
  
  const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v1047 = stdlib.protect(ctc4, await interact.in(), {
    at: './donate.rsh:1:23:application',
    fs: ['at ./donate.rsh:278:11:application call to [unknown function] (defined at: ./donate.rsh:278:11:function exp)', 'at ./donate.rsh:171:19:application call to "runBid_close0_160" (defined at: ./donate.rsh:278:11:function exp)', 'at ./donate.rsh:171:19:application call to [unknown function] (defined at: ./donate.rsh:171:19:function exp)'],
    msg: 'in',
    who: 'Bid_close'
    });
  
  const v1064 = ['Bid_close0_160', v1047];
  
  const txn1 = await (ctc.sendrecv({
    args: [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994, v1064],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:279:18:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./donate.rsh:279:22:decimal', stdlib.UInt_max, 0), v926]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn1;
      
      switch (v1109[0]) {
        case 'Bid_claim0_160': {
          const v1112 = v1109[1];
          
          break;
          }
        case 'Bid_close0_160': {
          const v1249 = v1109[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:279:18:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:279:22:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v926
            });
          undefined;
          const v1323 = null;
          const v1324 = await txn1.getOutput('Bid_close', 'v1323', ctc3, v1323);
          
          const v1330 = stdlib.lt(v969, v963);
          const v3483 = v962;
          const v3484 = v963;
          const v3485 = v964;
          const v3488 = v1111;
          const v3489 = v972;
          const v3490 = v973;
          const v3491 = v974;
          if (v1330) {
            const v3492 = stdlib.add(v962, v921);
            const v3493 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
            const v3494 = stdlib.mul(v3493, v922);
            const v3495 = stdlib.add(v962, v3494);
            const v3496 = stdlib.gt(v3492, v3495);
            const v3497 = v3496 ? v3492 : v3495;
            sim_r.isHalt = false;
            }
          else {
            const v3498 = stdlib.add(v962, v921);
            const v3499 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
            const v3500 = stdlib.mul(v3499, v922);
            const v3501 = stdlib.add(v962, v3500);
            const v3502 = stdlib.gt(v3498, v3501);
            const v3503 = v3502 ? v3498 : v3501;
            const v3504 = stdlib.div(v974, stdlib.checkedBigNumberify('./donate.rsh:299:34:decimal', stdlib.UInt_max, 100));
            const v3505 = stdlib.mul(v918, v3504);
            const v3506 = stdlib.add(v3505, v3504);
            const v3507 = stdlib.sub(v974, v3506);
            const v3508 = stdlib.ge(v962, v919);
            const v3509 = stdlib.add(v3507, v3505);
            const v3510 = stdlib.add(v3509, v3504);
            const v3511 = stdlib.sub(v974, v3510);
            sim_r.txns.push({
              amt: v3510,
              kind: 'from',
              to: v964,
              tok: v926
              });
            if (v3508) {
              sim_r.isHalt = false;
              }
            else {
              const v3518 = stdlib.sub(v973, v973);
              sim_r.txns.push({
                amt: v973,
                kind: 'from',
                to: v915,
                tok: v925
                });
              sim_r.isHalt = false;
              }}
          break;
          }
        case 'Bid_getBid0_160': {
          const v1386 = v1109[1];
          
          break;
          }
        case 'Bid_getPurchase0_160': {
          const v1523 = v1109[1];
          
          break;
          }
        case 'Bid_touch0_160': {
          const v1660 = v1109[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn1;
  switch (v1109[0]) {
    case 'Bid_claim0_160': {
      const v1112 = v1109[1];
      return;
      break;
      }
    case 'Bid_close0_160': {
      const v1249 = v1109[1];
      ;
      ;
      undefined;
      const v1323 = null;
      const v1324 = await txn1.getOutput('Bid_close', 'v1323', ctc3, v1323);
      if (v705) {
        stdlib.protect(ctc3, await interact.out(v1249, v1324), {
          at: './donate.rsh:278:12:application',
          fs: ['at ./donate.rsh:278:12:application call to [unknown function] (defined at: ./donate.rsh:278:12:function exp)', 'at ./donate.rsh:281:12:application call to "k" (defined at: ./donate.rsh:280:9:function exp)', 'at ./donate.rsh:280:9:application call to [unknown function] (defined at: ./donate.rsh:280:9:function exp)'],
          msg: 'out',
          who: 'Bid_close'
          });
        }
      else {
        }
      
      const v1330 = stdlib.lt(v969, v963);
      const v3483 = v962;
      const v3484 = v963;
      const v3485 = v964;
      const v3488 = v1111;
      const v3489 = v972;
      const v3490 = v973;
      const v3491 = v974;
      if (v1330) {
        const v3492 = stdlib.add(v962, v921);
        const v3493 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v3494 = stdlib.mul(v3493, v922);
        const v3495 = stdlib.add(v962, v3494);
        const v3496 = stdlib.gt(v3492, v3495);
        const v3497 = v3496 ? v3492 : v3495;
        return;
        }
      else {
        const v3498 = stdlib.add(v962, v921);
        const v3499 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v3500 = stdlib.mul(v3499, v922);
        const v3501 = stdlib.add(v962, v3500);
        const v3502 = stdlib.gt(v3498, v3501);
        const v3503 = v3502 ? v3498 : v3501;
        const v3504 = stdlib.div(v974, stdlib.checkedBigNumberify('./donate.rsh:299:34:decimal', stdlib.UInt_max, 100));
        const v3505 = stdlib.mul(v918, v3504);
        const v3506 = stdlib.add(v3505, v3504);
        const v3507 = stdlib.sub(v974, v3506);
        const v3508 = stdlib.ge(v962, v919);
        const v3509 = stdlib.add(v3507, v3505);
        const v3510 = stdlib.add(v3509, v3504);
        const v3511 = stdlib.sub(v974, v3510);
        ;
        if (v3508) {
          return;
          }
        else {
          const v3518 = stdlib.sub(v973, v973);
          ;
          return;
          }}
      break;
      }
    case 'Bid_getBid0_160': {
      const v1386 = v1109[1];
      return;
      break;
      }
    case 'Bid_getPurchase0_160': {
      const v1523 = v1109[1];
      return;
      break;
      }
    case 'Bid_touch0_160': {
      const v1660 = v1109[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_getBid(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_getBid expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_getBid expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Tuple([ctc1]);
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0_160: ctc5,
    Bid_close0_160: ctc5,
    Bid_getBid0_160: ctc3,
    Bid_getPurchase0_160: ctc3,
    Bid_touch0_160: ctc5
    });
  
  
  const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v1005 = stdlib.protect(ctc3, await interact.in(), {
    at: './donate.rsh:1:23:application',
    fs: ['at ./donate.rsh:207:9:application call to [unknown function] (defined at: ./donate.rsh:207:9:function exp)', 'at ./donate.rsh:171:19:application call to "runBid_getBid0_160" (defined at: ./donate.rsh:206:11:function exp)', 'at ./donate.rsh:171:19:application call to [unknown function] (defined at: ./donate.rsh:171:19:function exp)'],
    msg: 'in',
    who: 'Bid_getBid'
    });
  const v1006 = v1005[stdlib.checkedBigNumberify('./donate.rsh:206:11:spread', stdlib.UInt_max, 0)];
  const v1008 = stdlib.lt(v969, v963);
  const v1015 = stdlib.ge(v1006, v994);
  const v1016 = v1008 ? v1015 : false;
  const v1017 = stdlib.ge(v1006, v920);
  const v1018 = v1016 ? v1017 : false;
  stdlib.assert(v1018, {
    at: './donate.rsh:207:25:application',
    fs: ['at ./donate.rsh:207:9:application call to [unknown function] (defined at: ./donate.rsh:207:16:function exp)', 'at ./donate.rsh:207:9:application call to [unknown function] (defined at: ./donate.rsh:207:9:function exp)', 'at ./donate.rsh:171:19:application call to "runBid_getBid0_160" (defined at: ./donate.rsh:206:11:function exp)', 'at ./donate.rsh:171:19:application call to [unknown function] (defined at: ./donate.rsh:171:19:function exp)'],
    msg: null,
    who: 'Bid_getBid'
    });
  
  const v1075 = ['Bid_getBid0_160', v1005];
  
  const txn1 = await (ctc.sendrecv({
    args: [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994, v1075],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:211:20:decimal', stdlib.UInt_max, 0), [[v1006, v926]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn1;
      
      switch (v1109[0]) {
        case 'Bid_claim0_160': {
          const v1112 = v1109[1];
          
          break;
          }
        case 'Bid_close0_160': {
          const v1249 = v1109[1];
          
          break;
          }
        case 'Bid_getBid0_160': {
          const v1386 = v1109[1];
          const v1407 = v1386[stdlib.checkedBigNumberify('./donate.rsh:206:11:spread', stdlib.UInt_max, 0)];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:211:20:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v1440 = stdlib.add(v974, v1407);
          sim_r.txns.push({
            amt: v1407,
            kind: 'to',
            tok: v926
            });
          undefined;
          const v1479 = stdlib.ge(v1407, v994);
          const v1480 = v1008 ? v1479 : false;
          const v1481 = stdlib.ge(v1407, v920);
          const v1482 = v1480 ? v1481 : false;
          stdlib.assert(v1482, {
            at: './donate.rsh:213:18:application',
            fs: ['at ./donate.rsh:212:9:application call to [unknown function] (defined at: ./donate.rsh:212:9:function exp)'],
            msg: null,
            who: 'Bid_getBid'
            });
          const v1486 = stdlib.sub(v1440, v962);
          sim_r.txns.push({
            amt: v962,
            kind: 'from',
            to: v964,
            tok: v926
            });
          const v1487 = null;
          const v1488 = await txn1.getOutput('Bid_getBid', 'v1487', ctc4, v1487);
          
          const v1493 = stdlib.add(v963, stdlib.checkedBigNumberify('./donate.rsh:162:33:decimal', stdlib.UInt_max, 60));
          const v3735 = v1407;
          const v3736 = v1493;
          const v3737 = v1108;
          const v3740 = v1111;
          const v3741 = v972;
          const v3742 = v973;
          const v3743 = v1486;
          const v3744 = stdlib.add(v1407, v921);
          const v3745 = stdlib.div(v1407, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v3746 = stdlib.mul(v3745, v922);
          const v3747 = stdlib.add(v1407, v3746);
          const v3748 = stdlib.gt(v3744, v3747);
          const v3749 = v3748 ? v3744 : v3747;
          sim_r.isHalt = false;
          
          break;
          }
        case 'Bid_getPurchase0_160': {
          const v1523 = v1109[1];
          
          break;
          }
        case 'Bid_touch0_160': {
          const v1660 = v1109[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn1;
  switch (v1109[0]) {
    case 'Bid_claim0_160': {
      const v1112 = v1109[1];
      return;
      break;
      }
    case 'Bid_close0_160': {
      const v1249 = v1109[1];
      return;
      break;
      }
    case 'Bid_getBid0_160': {
      const v1386 = v1109[1];
      const v1407 = v1386[stdlib.checkedBigNumberify('./donate.rsh:206:11:spread', stdlib.UInt_max, 0)];
      ;
      const v1440 = stdlib.add(v974, v1407);
      ;
      undefined;
      const v1479 = stdlib.ge(v1407, v994);
      const v1480 = v1008 ? v1479 : false;
      const v1481 = stdlib.ge(v1407, v920);
      const v1482 = v1480 ? v1481 : false;
      stdlib.assert(v1482, {
        at: './donate.rsh:213:18:application',
        fs: ['at ./donate.rsh:212:9:application call to [unknown function] (defined at: ./donate.rsh:212:9:function exp)'],
        msg: null,
        who: 'Bid_getBid'
        });
      const v1486 = stdlib.sub(v1440, v962);
      ;
      const v1487 = null;
      const v1488 = await txn1.getOutput('Bid_getBid', 'v1487', ctc4, v1487);
      if (v705) {
        stdlib.protect(ctc4, await interact.out(v1386, v1488), {
          at: './donate.rsh:206:12:application',
          fs: ['at ./donate.rsh:206:12:application call to [unknown function] (defined at: ./donate.rsh:206:12:function exp)', 'at ./donate.rsh:218:12:application call to "k" (defined at: ./donate.rsh:212:9:function exp)', 'at ./donate.rsh:212:9:application call to [unknown function] (defined at: ./donate.rsh:212:9:function exp)'],
          msg: 'out',
          who: 'Bid_getBid'
          });
        }
      else {
        }
      
      const v1493 = stdlib.add(v963, stdlib.checkedBigNumberify('./donate.rsh:162:33:decimal', stdlib.UInt_max, 60));
      const v3735 = v1407;
      const v3736 = v1493;
      const v3737 = v1108;
      const v3740 = v1111;
      const v3741 = v972;
      const v3742 = v973;
      const v3743 = v1486;
      const v3744 = stdlib.add(v1407, v921);
      const v3745 = stdlib.div(v1407, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v3746 = stdlib.mul(v3745, v922);
      const v3747 = stdlib.add(v1407, v3746);
      const v3748 = stdlib.gt(v3744, v3747);
      const v3749 = v3748 ? v3744 : v3747;
      return;
      
      break;
      }
    case 'Bid_getPurchase0_160': {
      const v1523 = v1109[1];
      return;
      break;
      }
    case 'Bid_touch0_160': {
      const v1660 = v1109[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_getPurchase(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_getPurchase expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_getPurchase expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Tuple([ctc1]);
  const ctc4 = stdlib.T_Null;
  const ctc5 = stdlib.T_Tuple([ctc4]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0_160: ctc5,
    Bid_close0_160: ctc5,
    Bid_getBid0_160: ctc3,
    Bid_getPurchase0_160: ctc3,
    Bid_touch0_160: ctc5
    });
  
  
  const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v1024 = stdlib.protect(ctc3, await interact.in(), {
    at: './donate.rsh:1:23:application',
    fs: ['at ./donate.rsh:232:9:application call to [unknown function] (defined at: ./donate.rsh:232:9:function exp)', 'at ./donate.rsh:171:19:application call to "runBid_getPurchase0_160" (defined at: ./donate.rsh:231:11:function exp)', 'at ./donate.rsh:171:19:application call to [unknown function] (defined at: ./donate.rsh:171:19:function exp)'],
    msg: 'in',
    who: 'Bid_getPurchase'
    });
  const v1025 = v1024[stdlib.checkedBigNumberify('./donate.rsh:231:11:spread', stdlib.UInt_max, 0)];
  const v1027 = stdlib.ge(v969, v963);
  const v1028 = stdlib.lt(v962, v919);
  const v1029 = v1027 ? v1028 : false;
  const v1030 = stdlib.ge(v1025, v919);
  const v1031 = v1029 ? v1030 : false;
  stdlib.assert(v1031, {
    at: './donate.rsh:232:25:application',
    fs: ['at ./donate.rsh:232:9:application call to [unknown function] (defined at: ./donate.rsh:232:16:function exp)', 'at ./donate.rsh:232:9:application call to [unknown function] (defined at: ./donate.rsh:232:9:function exp)', 'at ./donate.rsh:171:19:application call to "runBid_getPurchase0_160" (defined at: ./donate.rsh:231:11:function exp)', 'at ./donate.rsh:171:19:application call to [unknown function] (defined at: ./donate.rsh:171:19:function exp)'],
    msg: null,
    who: 'Bid_getPurchase'
    });
  
  const v1086 = ['Bid_getPurchase0_160', v1024];
  
  const txn1 = await (ctc.sendrecv({
    args: [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994, v1086],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:237:20:decimal', stdlib.UInt_max, 0), [[v1025, v926]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn1;
      
      switch (v1109[0]) {
        case 'Bid_claim0_160': {
          const v1112 = v1109[1];
          
          break;
          }
        case 'Bid_close0_160': {
          const v1249 = v1109[1];
          
          break;
          }
        case 'Bid_getBid0_160': {
          const v1386 = v1109[1];
          
          break;
          }
        case 'Bid_getPurchase0_160': {
          const v1523 = v1109[1];
          const v1552 = v1523[stdlib.checkedBigNumberify('./donate.rsh:231:11:spread', stdlib.UInt_max, 0)];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:237:20:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          const v1577 = stdlib.add(v974, v1552);
          sim_r.txns.push({
            amt: v1552,
            kind: 'to',
            tok: v926
            });
          undefined;
          const v1638 = stdlib.ge(v1552, v919);
          const v1639 = v1029 ? v1638 : false;
          stdlib.assert(v1639, {
            at: './donate.rsh:239:18:application',
            fs: ['at ./donate.rsh:238:9:application call to [unknown function] (defined at: ./donate.rsh:238:9:function exp)'],
            msg: null,
            who: 'Bid_getPurchase'
            });
          const v1643 = stdlib.sub(v1577, v962);
          sim_r.txns.push({
            amt: v962,
            kind: 'from',
            to: v964,
            tok: v926
            });
          const v1644 = null;
          const v1645 = await txn1.getOutput('Bid_getPurchase', 'v1644', ctc4, v1644);
          
          const v3987 = v1552;
          const v3988 = v963;
          const v3989 = v1108;
          const v3993 = v972;
          const v3994 = v973;
          const v4002 = stdlib.add(v1552, v921);
          const v4003 = stdlib.div(v1552, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v4004 = stdlib.mul(v4003, v922);
          const v4005 = stdlib.add(v1552, v4004);
          const v4006 = stdlib.gt(v4002, v4005);
          const v4007 = v4006 ? v4002 : v4005;
          const v4008 = stdlib.div(v1643, stdlib.checkedBigNumberify('./donate.rsh:299:34:decimal', stdlib.UInt_max, 100));
          const v4009 = stdlib.mul(v918, v4008);
          const v4010 = stdlib.add(v4009, v4008);
          const v4011 = stdlib.sub(v1643, v4010);
          const v4013 = stdlib.add(v4011, v4009);
          const v4014 = stdlib.add(v4013, v4008);
          const v4015 = stdlib.sub(v1643, v4014);
          sim_r.txns.push({
            amt: v4014,
            kind: 'from',
            to: v1108,
            tok: v926
            });
          if (v1638) {
            sim_r.isHalt = false;
            }
          else {
            const v4022 = stdlib.sub(v973, v973);
            sim_r.txns.push({
              amt: v973,
              kind: 'from',
              to: v915,
              tok: v925
              });
            sim_r.isHalt = false;
            }
          break;
          }
        case 'Bid_touch0_160': {
          const v1660 = v1109[1];
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn1;
  switch (v1109[0]) {
    case 'Bid_claim0_160': {
      const v1112 = v1109[1];
      return;
      break;
      }
    case 'Bid_close0_160': {
      const v1249 = v1109[1];
      return;
      break;
      }
    case 'Bid_getBid0_160': {
      const v1386 = v1109[1];
      return;
      break;
      }
    case 'Bid_getPurchase0_160': {
      const v1523 = v1109[1];
      const v1552 = v1523[stdlib.checkedBigNumberify('./donate.rsh:231:11:spread', stdlib.UInt_max, 0)];
      ;
      const v1577 = stdlib.add(v974, v1552);
      ;
      undefined;
      const v1638 = stdlib.ge(v1552, v919);
      const v1639 = v1029 ? v1638 : false;
      stdlib.assert(v1639, {
        at: './donate.rsh:239:18:application',
        fs: ['at ./donate.rsh:238:9:application call to [unknown function] (defined at: ./donate.rsh:238:9:function exp)'],
        msg: null,
        who: 'Bid_getPurchase'
        });
      const v1643 = stdlib.sub(v1577, v962);
      ;
      const v1644 = null;
      const v1645 = await txn1.getOutput('Bid_getPurchase', 'v1644', ctc4, v1644);
      if (v705) {
        stdlib.protect(ctc4, await interact.out(v1523, v1645), {
          at: './donate.rsh:231:12:application',
          fs: ['at ./donate.rsh:231:12:application call to [unknown function] (defined at: ./donate.rsh:231:12:function exp)', 'at ./donate.rsh:245:12:application call to "k" (defined at: ./donate.rsh:238:9:function exp)', 'at ./donate.rsh:238:9:application call to [unknown function] (defined at: ./donate.rsh:238:9:function exp)'],
          msg: 'out',
          who: 'Bid_getPurchase'
          });
        }
      else {
        }
      
      const v3987 = v1552;
      const v3988 = v963;
      const v3989 = v1108;
      const v3993 = v972;
      const v3994 = v973;
      const v4002 = stdlib.add(v1552, v921);
      const v4003 = stdlib.div(v1552, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v4004 = stdlib.mul(v4003, v922);
      const v4005 = stdlib.add(v1552, v4004);
      const v4006 = stdlib.gt(v4002, v4005);
      const v4007 = v4006 ? v4002 : v4005;
      const v4008 = stdlib.div(v1643, stdlib.checkedBigNumberify('./donate.rsh:299:34:decimal', stdlib.UInt_max, 100));
      const v4009 = stdlib.mul(v918, v4008);
      const v4010 = stdlib.add(v4009, v4008);
      const v4011 = stdlib.sub(v1643, v4010);
      const v4013 = stdlib.add(v4011, v4009);
      const v4014 = stdlib.add(v4013, v4008);
      const v4015 = stdlib.sub(v1643, v4014);
      ;
      if (v1638) {
        return;
        }
      else {
        const v4022 = stdlib.sub(v973, v973);
        ;
        return;
        }
      break;
      }
    case 'Bid_touch0_160': {
      const v1660 = v1109[1];
      return;
      break;
      }
    }
  
  
  };
export async function Bid_touch(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Bid_touch expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Bid_touch expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0_160: ctc4,
    Bid_close0_160: ctc4,
    Bid_getBid0_160: ctc5,
    Bid_getPurchase0_160: ctc5,
    Bid_touch0_160: ctc4
    });
  
  
  const [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994] = await ctc.getState(stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 10), [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1]);
  const v997 = stdlib.protect(ctc4, await interact.in(), {
    at: './donate.rsh:1:23:application',
    fs: ['at ./donate.rsh:190:11:application call to [unknown function] (defined at: ./donate.rsh:190:11:function exp)', 'at ./donate.rsh:171:19:application call to "runBid_touch0_160" (defined at: ./donate.rsh:190:11:function exp)', 'at ./donate.rsh:171:19:application call to [unknown function] (defined at: ./donate.rsh:171:19:function exp)'],
    msg: 'in',
    who: 'Bid_touch'
    });
  
  const v1097 = ['Bid_touch0_160', v997];
  
  const txn1 = await (ctc.sendrecv({
    args: [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v962, v963, v964, v969, v972, v973, v974, v994, v1097],
    evt_cnt: 1,
    funcNum: 6,
    lct: stdlib.checkedBigNumberify('<builtin>', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc6],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:191:18:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./donate.rsh:191:22:decimal', stdlib.UInt_max, 0), v926]]],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn1;
      
      switch (v1109[0]) {
        case 'Bid_claim0_160': {
          const v1112 = v1109[1];
          
          break;
          }
        case 'Bid_close0_160': {
          const v1249 = v1109[1];
          
          break;
          }
        case 'Bid_getBid0_160': {
          const v1386 = v1109[1];
          
          break;
          }
        case 'Bid_getPurchase0_160': {
          const v1523 = v1109[1];
          
          break;
          }
        case 'Bid_touch0_160': {
          const v1660 = v1109[1];
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:191:18:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: undefined
            });
          sim_r.txns.push({
            amt: stdlib.checkedBigNumberify('./donate.rsh:191:22:decimal', stdlib.UInt_max, 0),
            kind: 'to',
            tok: v926
            });
          undefined;
          const v1790 = null;
          const v1791 = await txn1.getOutput('Bid_touch', 'v1790', ctc3, v1790);
          
          const v4239 = v962;
          const v4240 = v963;
          const v4241 = v964;
          const v4244 = v1111;
          const v4245 = v972;
          const v4246 = v973;
          const v4247 = v974;
          const v4248 = stdlib.add(v962, v921);
          const v4249 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
          const v4250 = stdlib.mul(v4249, v922);
          const v4251 = stdlib.add(v962, v4250);
          const v4252 = stdlib.gt(v4248, v4251);
          const v4253 = v4252 ? v4248 : v4251;
          sim_r.isHalt = false;
          
          break;
          }
        }
      return sim_r;
      }),
    soloSend: false,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc6],
    waitIfNotPresent: false
    }));
  const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn1;
  switch (v1109[0]) {
    case 'Bid_claim0_160': {
      const v1112 = v1109[1];
      return;
      break;
      }
    case 'Bid_close0_160': {
      const v1249 = v1109[1];
      return;
      break;
      }
    case 'Bid_getBid0_160': {
      const v1386 = v1109[1];
      return;
      break;
      }
    case 'Bid_getPurchase0_160': {
      const v1523 = v1109[1];
      return;
      break;
      }
    case 'Bid_touch0_160': {
      const v1660 = v1109[1];
      ;
      ;
      undefined;
      const v1790 = null;
      const v1791 = await txn1.getOutput('Bid_touch', 'v1790', ctc3, v1790);
      if (v705) {
        stdlib.protect(ctc3, await interact.out(v1660, v1791), {
          at: './donate.rsh:190:12:application',
          fs: ['at ./donate.rsh:190:12:application call to [unknown function] (defined at: ./donate.rsh:190:12:function exp)', 'at ./donate.rsh:193:12:application call to "k" (defined at: ./donate.rsh:192:9:function exp)', 'at ./donate.rsh:192:9:application call to [unknown function] (defined at: ./donate.rsh:192:9:function exp)'],
          msg: 'out',
          who: 'Bid_touch'
          });
        }
      else {
        }
      
      const v4239 = v962;
      const v4240 = v963;
      const v4241 = v964;
      const v4244 = v1111;
      const v4245 = v972;
      const v4246 = v973;
      const v4247 = v974;
      const v4248 = stdlib.add(v962, v921);
      const v4249 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
      const v4250 = stdlib.mul(v4249, v922);
      const v4251 = stdlib.add(v962, v4250);
      const v4252 = stdlib.gt(v4248, v4251);
      const v4253 = v4252 ? v4248 : v4251;
      return;
      
      break;
      }
    }
  
  
  };
export async function Constructor(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Constructor expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Constructor expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_Object({
    addr: ctc0,
    addr2: ctc0,
    addr3: ctc0,
    addr4: ctc0
    });
  const ctc2 = stdlib.T_Null;
  const ctc3 = stdlib.T_UInt;
  const ctc4 = stdlib.T_Token;
  const ctc5 = stdlib.T_Tuple([ctc2]);
  const ctc6 = stdlib.T_Tuple([ctc3]);
  const ctc7 = stdlib.T_Data({
    Bid_claim0_160: ctc5,
    Bid_close0_160: ctc5,
    Bid_getBid0_160: ctc6,
    Bid_getPurchase0_160: ctc6,
    Bid_touch0_160: ctc5
    });
  
  
  const v874 = stdlib.protect(ctc1, await interact.getParams(), {
    at: './util.rsh:43:38:application',
    fs: ['at ./util.rsh:37:19:application call to [unknown function] (defined at: ./util.rsh:37:23:function exp)', 'at ./donate.rsh:78:50:application call to "construct" (defined at: ./util.rsh:36:47:function exp)'],
    msg: 'getParams',
    who: 'Constructor'
    });
  const v875 = v874.addr;
  const v876 = v874.addr2;
  const v877 = v874.addr3;
  const v878 = v874.addr4;
  
  const txn1 = await (ctc.sendrecv({
    args: [v875, v876, v877, v878],
    evt_cnt: 4,
    funcNum: 0,
    lct: stdlib.checkedBigNumberify('./util.rsh:47:6:dot', stdlib.UInt_max, 0),
    onlyIf: true,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    pay: [stdlib.checkedBigNumberify('./util.rsh:47:6:decimal', stdlib.UInt_max, 0), []],
    sim_p: (async (txn1) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [v880, v881, v882, v883], secs: v885, time: v884, didSend: v36, from: v879 } = txn1;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./util.rsh:47:6:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      const v887 = v883;
      sim_r.isHalt = false;
      
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0],
    waitIfNotPresent: false
    }));
  const {data: [v880, v881, v882, v883], secs: v885, time: v884, didSend: v36, from: v879 } = txn1;
  ;
  const v887 = v883;
  stdlib.protect(ctc2, await interact.signal(), {
    at: './util.rsh:55:41:application',
    fs: ['at ./util.rsh:55:19:application call to [unknown function] (defined at: ./util.rsh:55:23:function exp)', 'at ./donate.rsh:78:50:application call to "construct" (defined at: ./util.rsh:36:47:function exp)'],
    msg: 'signal',
    who: 'Constructor'
    });
  
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 14,
    funcNum: 1,
    out_tys: [ctc0, ctc0, ctc3, ctc3, ctc3, ctc3, ctc3, ctc3, ctc3, ctc4, ctc4, ctc3, ctc3, ctc3],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v916, v917, v918, v919, v920, v921, v922, v923, v924, v925, v926, v927, v928, v929], secs: v931, time: v930, didSend: v89, from: v915 } = txn2;
  const v932 = stdlib.tokenEq(v925, v926);
  const v933 = v932 ? false : true;
  stdlib.assert(v933, {
    at: './donate.rsh:107:6:dot',
    fs: [],
    msg: 'non-network tokens distinct',
    who: 'Constructor'
    });
  ;
  ;
  ;
  stdlib.assert(v933, {
    at: './donate.rsh:125:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v938 = stdlib.ge(v918, stdlib.checkedBigNumberify('./donate.rsh:126:27:decimal', stdlib.UInt_max, 0));
  const v939 = stdlib.le(v918, stdlib.checkedBigNumberify('./donate.rsh:126:48:decimal', stdlib.UInt_max, 99));
  const v940 = v938 ? v939 : false;
  stdlib.assert(v940, {
    at: './donate.rsh:126:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v941 = stdlib.ge(v920, stdlib.checkedBigNumberify('./donate.rsh:127:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v941, {
    at: './donate.rsh:127:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v942 = stdlib.lt(v920, v919);
  stdlib.assert(v942, {
    at: './donate.rsh:128:10:application',
    fs: [],
    msg: null,
    who: 'Constructor'
    });
  const v946 = stdlib.sub(stdlib.checkedBigNumberify('./donate.rsh:124:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./donate.rsh:131:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v950 = stdlib.sub(v946, stdlib.checkedBigNumberify('./donate.rsh:132:12:decimal', stdlib.UInt_max, 80000));
  ;
  const v951 = v915;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v954, time: v953, didSend: v114, from: v952 } = txn3;
  ;
  ;
  const v958 = stdlib.addressEq(v951, v952);
  stdlib.assert(v958, {
    at: './donate.rsh:138:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Constructor'
    });
  let v962 = stdlib.checkedBigNumberify('./donate.rsh:174:24:decimal', stdlib.UInt_max, 0);
  let v963 = v929;
  let v964 = v915;
  let v965 = true;
  let v966 = v953;
  let v969 = v954;
  let v972 = v950;
  let v973 = stdlib.checkedBigNumberify('./donate.rsh:138:15:decimal', stdlib.UInt_max, 1);
  let v974 = stdlib.checkedBigNumberify('./donate.rsh:107:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v965;})()) {
    const v989 = stdlib.add(v962, v921);
    const v990 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v991 = stdlib.mul(v990, v922);
    const v992 = stdlib.add(v962, v991);
    const v993 = stdlib.gt(v989, v992);
    const v994 = v993 ? v989 : v992;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc7],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn4;
    switch (v1109[0]) {
      case 'Bid_claim0_160': {
        const v1112 = v1109[1];
        ;
        ;
        undefined;
        const v1169 = stdlib.addressEq(v1108, v916);
        const v1170 = stdlib.ge(v962, v919);
        const v1171 = v1169 ? v1170 : false;
        stdlib.assert(v1171, {
          at: './donate.rsh:263:18:application',
          fs: ['at ./donate.rsh:262:9:application call to [unknown function] (defined at: ./donate.rsh:262:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v1176 = stdlib.sub(v973, v973);
        ;
        const v1177 = null;
        await txn4.getOutput('Bid_claim', 'v1177', ctc2, v1177);
        const cv962 = v962;
        const cv963 = v963;
        const cv964 = v964;
        const cv965 = false;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v1176;
        const cv974 = v974;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_close0_160': {
        const v1249 = v1109[1];
        ;
        ;
        undefined;
        const v1323 = null;
        await txn4.getOutput('Bid_close', 'v1323', ctc2, v1323);
        const v1330 = stdlib.lt(v969, v963);
        const cv962 = v962;
        const cv963 = v963;
        const cv964 = v964;
        const cv965 = v1330;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v974;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_getBid0_160': {
        const v1386 = v1109[1];
        const v1407 = v1386[stdlib.checkedBigNumberify('./donate.rsh:206:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1440 = stdlib.add(v974, v1407);
        ;
        undefined;
        const v1472 = stdlib.lt(v969, v963);
        const v1479 = stdlib.ge(v1407, v994);
        const v1480 = v1472 ? v1479 : false;
        const v1481 = stdlib.ge(v1407, v920);
        const v1482 = v1480 ? v1481 : false;
        stdlib.assert(v1482, {
          at: './donate.rsh:213:18:application',
          fs: ['at ./donate.rsh:212:9:application call to [unknown function] (defined at: ./donate.rsh:212:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v1486 = stdlib.sub(v1440, v962);
        ;
        const v1487 = null;
        await txn4.getOutput('Bid_getBid', 'v1487', ctc2, v1487);
        const v1493 = stdlib.add(v963, stdlib.checkedBigNumberify('./donate.rsh:162:33:decimal', stdlib.UInt_max, 60));
        const cv962 = v1407;
        const cv963 = v1493;
        const cv964 = v1108;
        const cv965 = true;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v1486;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0_160': {
        const v1523 = v1109[1];
        const v1552 = v1523[stdlib.checkedBigNumberify('./donate.rsh:231:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1577 = stdlib.add(v974, v1552);
        ;
        undefined;
        const v1635 = stdlib.ge(v969, v963);
        const v1636 = stdlib.lt(v962, v919);
        const v1637 = v1635 ? v1636 : false;
        const v1638 = stdlib.ge(v1552, v919);
        const v1639 = v1637 ? v1638 : false;
        stdlib.assert(v1639, {
          at: './donate.rsh:239:18:application',
          fs: ['at ./donate.rsh:238:9:application call to [unknown function] (defined at: ./donate.rsh:238:9:function exp)'],
          msg: null,
          who: 'Constructor'
          });
        const v1643 = stdlib.sub(v1577, v962);
        ;
        const v1644 = null;
        await txn4.getOutput('Bid_getPurchase', 'v1644', ctc2, v1644);
        const cv962 = v1552;
        const cv963 = v963;
        const cv964 = v1108;
        const cv965 = false;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v1643;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_touch0_160': {
        const v1660 = v1109[1];
        ;
        ;
        undefined;
        const v1790 = null;
        await txn4.getOutput('Bid_touch', 'v1790', ctc2, v1790);
        const cv962 = v962;
        const cv963 = v963;
        const cv964 = v964;
        const cv965 = true;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v974;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      }
    
    }
  const v1797 = stdlib.add(v962, v921);
  const v1798 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1799 = stdlib.mul(v1798, v922);
  const v1800 = stdlib.add(v962, v1799);
  const v1801 = stdlib.gt(v1797, v1800);
  const v1802 = v1801 ? v1797 : v1800;
  const v1804 = stdlib.div(v974, stdlib.checkedBigNumberify('./donate.rsh:299:34:decimal', stdlib.UInt_max, 100));
  const v1805 = stdlib.mul(v918, v1804);
  const v1807 = stdlib.add(v1805, v1804);
  const v1808 = stdlib.sub(v974, v1807);
  const v1809 = stdlib.ge(v962, v919);
  const v1810 = stdlib.add(v1808, v1805);
  const v1811 = stdlib.add(v1810, v1804);
  const v1815 = stdlib.sub(v974, v1811);
  ;
  if (v1809) {
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1819, time: v1818, didSend: v833, from: v1817 } = txn4;
    ;
    const v1821 = stdlib.addressEq(v887, v1817);
    stdlib.assert(v1821, {
      at: './donate.rsh:335:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Constructor'
      });
    if (v1809) {
      const v1826 = stdlib.sub(v973, v973);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1875 = stdlib.sub(v973, v973);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1879, time: v1878, didSend: v833, from: v1877 } = txn4;
    ;
    const v1881 = stdlib.addressEq(v887, v1877);
    stdlib.assert(v1881, {
      at: './donate.rsh:335:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Constructor'
      });
    if (v1809) {
      const v1886 = stdlib.sub(v1875, v1875);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
export async function Depositer(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Depositer expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Depositer expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0_160: ctc4,
    Bid_close0_160: ctc4,
    Bid_getBid0_160: ctc5,
    Bid_getPurchase0_160: ctc5,
    Bid_touch0_160: ctc4
    });
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v880, v881, v882, v883], secs: v885, time: v884, didSend: v36, from: v879 } = txn1;
  ;
  const v887 = v883;
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 14,
    funcNum: 1,
    out_tys: [ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v916, v917, v918, v919, v920, v921, v922, v923, v924, v925, v926, v927, v928, v929], secs: v931, time: v930, didSend: v89, from: v915 } = txn2;
  const v932 = stdlib.tokenEq(v925, v926);
  const v933 = v932 ? false : true;
  stdlib.assert(v933, {
    at: './donate.rsh:107:6:dot',
    fs: [],
    msg: 'non-network tokens distinct',
    who: 'Depositer'
    });
  ;
  ;
  ;
  stdlib.assert(v933, {
    at: './donate.rsh:125:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v938 = stdlib.ge(v918, stdlib.checkedBigNumberify('./donate.rsh:126:27:decimal', stdlib.UInt_max, 0));
  const v939 = stdlib.le(v918, stdlib.checkedBigNumberify('./donate.rsh:126:48:decimal', stdlib.UInt_max, 99));
  const v940 = v938 ? v939 : false;
  stdlib.assert(v940, {
    at: './donate.rsh:126:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v941 = stdlib.ge(v920, stdlib.checkedBigNumberify('./donate.rsh:127:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v941, {
    at: './donate.rsh:127:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v942 = stdlib.lt(v920, v919);
  stdlib.assert(v942, {
    at: './donate.rsh:128:10:application',
    fs: [],
    msg: null,
    who: 'Depositer'
    });
  const v946 = stdlib.sub(stdlib.checkedBigNumberify('./donate.rsh:124:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./donate.rsh:131:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v950 = stdlib.sub(v946, stdlib.checkedBigNumberify('./donate.rsh:132:12:decimal', stdlib.UInt_max, 80000));
  ;
  const v951 = ctc.iam(v915);
  const txn3 = await (ctc.sendrecv({
    args: [v881, v883, v887, v915, v916, v918, v919, v920, v921, v922, v925, v926, v929, v950, v951],
    evt_cnt: 0,
    funcNum: 2,
    lct: v930,
    onlyIf: true,
    out_tys: [],
    pay: [stdlib.checkedBigNumberify('./donate.rsh:138:11:decimal', stdlib.UInt_max, 0), [[stdlib.checkedBigNumberify('./donate.rsh:138:15:decimal', stdlib.UInt_max, 1), v925]]],
    sim_p: (async (txn3) => {
      const sim_r = { txns: [], mapRefs: [], maps: [] };
      
      const {data: [], secs: v954, time: v953, didSend: v114, from: v952 } = txn3;
      
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./donate.rsh:138:11:decimal', stdlib.UInt_max, 0),
        kind: 'to',
        tok: undefined
        });
      sim_r.txns.push({
        amt: stdlib.checkedBigNumberify('./donate.rsh:138:15:decimal', stdlib.UInt_max, 1),
        kind: 'to',
        tok: v925
        });
      const v958 = stdlib.addressEq(v951, v952);
      stdlib.assert(v958, {
        at: './donate.rsh:138:6:dot',
        fs: [],
        msg: 'sender correct',
        who: 'Depositer'
        });
      
      const v962 = stdlib.checkedBigNumberify('./donate.rsh:174:24:decimal', stdlib.UInt_max, 0);
      const v963 = v929;
      const v964 = v915;
      const v965 = true;
      const v966 = v953;
      const v969 = v954;
      const v972 = v950;
      const v973 = stdlib.checkedBigNumberify('./donate.rsh:138:15:decimal', stdlib.UInt_max, 1);
      const v974 = stdlib.checkedBigNumberify('./donate.rsh:107:6:dot', stdlib.UInt_max, 0);
      
      if (await (async () => {
        
        return v965;})()) {
        const v989 = stdlib.add(v962, v921);
        const v990 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v991 = stdlib.mul(v990, v922);
        const v992 = stdlib.add(v962, v991);
        const v993 = stdlib.gt(v989, v992);
        const v994 = v993 ? v989 : v992;
        sim_r.isHalt = false;
        }
      else {
        const v1797 = stdlib.add(v962, v921);
        const v1798 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
        const v1799 = stdlib.mul(v1798, v922);
        const v1800 = stdlib.add(v962, v1799);
        const v1801 = stdlib.gt(v1797, v1800);
        const v1802 = v1801 ? v1797 : v1800;
        const v1804 = stdlib.div(v974, stdlib.checkedBigNumberify('./donate.rsh:299:34:decimal', stdlib.UInt_max, 100));
        const v1805 = stdlib.mul(v918, v1804);
        const v1807 = stdlib.add(v1805, v1804);
        const v1808 = stdlib.sub(v974, v1807);
        const v1809 = stdlib.ge(v962, v919);
        const v1810 = stdlib.add(v1808, v1805);
        const v1811 = stdlib.add(v1810, v1804);
        const v1815 = stdlib.sub(v974, v1811);
        sim_r.txns.push({
          amt: v1811,
          kind: 'from',
          to: v964,
          tok: v926
          });
        if (v1809) {
          sim_r.isHalt = false;
          }
        else {
          const v1875 = stdlib.sub(v973, v973);
          sim_r.txns.push({
            amt: v973,
            kind: 'from',
            to: v915,
            tok: v925
            });
          sim_r.isHalt = false;
          }}
      return sim_r;
      }),
    soloSend: true,
    timeoutAt: undefined,
    tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0],
    waitIfNotPresent: false
    }));
  const {data: [], secs: v954, time: v953, didSend: v114, from: v952 } = txn3;
  ;
  ;
  const v958 = stdlib.addressEq(v951, v952);
  stdlib.assert(v958, {
    at: './donate.rsh:138:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Depositer'
    });
  stdlib.protect(ctc3, await interact.signal(), {
    at: './donate.rsh:140:39:application',
    fs: ['at ./donate.rsh:140:17:application call to [unknown function] (defined at: ./donate.rsh:140:21:function exp)'],
    msg: 'signal',
    who: 'Depositer'
    });
  
  let v962 = stdlib.checkedBigNumberify('./donate.rsh:174:24:decimal', stdlib.UInt_max, 0);
  let v963 = v929;
  let v964 = v915;
  let v965 = true;
  let v966 = v953;
  let v969 = v954;
  let v972 = v950;
  let v973 = stdlib.checkedBigNumberify('./donate.rsh:138:15:decimal', stdlib.UInt_max, 1);
  let v974 = stdlib.checkedBigNumberify('./donate.rsh:107:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v965;})()) {
    const v989 = stdlib.add(v962, v921);
    const v990 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v991 = stdlib.mul(v990, v922);
    const v992 = stdlib.add(v962, v991);
    const v993 = stdlib.gt(v989, v992);
    const v994 = v993 ? v989 : v992;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc6],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn4;
    switch (v1109[0]) {
      case 'Bid_claim0_160': {
        const v1112 = v1109[1];
        ;
        ;
        undefined;
        const v1169 = stdlib.addressEq(v1108, v916);
        const v1170 = stdlib.ge(v962, v919);
        const v1171 = v1169 ? v1170 : false;
        stdlib.assert(v1171, {
          at: './donate.rsh:263:18:application',
          fs: ['at ./donate.rsh:262:9:application call to [unknown function] (defined at: ./donate.rsh:262:9:function exp)'],
          msg: null,
          who: 'Depositer'
          });
        const v1176 = stdlib.sub(v973, v973);
        ;
        const v1177 = null;
        await txn4.getOutput('Bid_claim', 'v1177', ctc3, v1177);
        const cv962 = v962;
        const cv963 = v963;
        const cv964 = v964;
        const cv965 = false;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v1176;
        const cv974 = v974;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_close0_160': {
        const v1249 = v1109[1];
        ;
        ;
        undefined;
        const v1323 = null;
        await txn4.getOutput('Bid_close', 'v1323', ctc3, v1323);
        const v1330 = stdlib.lt(v969, v963);
        const cv962 = v962;
        const cv963 = v963;
        const cv964 = v964;
        const cv965 = v1330;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v974;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_getBid0_160': {
        const v1386 = v1109[1];
        const v1407 = v1386[stdlib.checkedBigNumberify('./donate.rsh:206:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1440 = stdlib.add(v974, v1407);
        ;
        undefined;
        const v1472 = stdlib.lt(v969, v963);
        const v1479 = stdlib.ge(v1407, v994);
        const v1480 = v1472 ? v1479 : false;
        const v1481 = stdlib.ge(v1407, v920);
        const v1482 = v1480 ? v1481 : false;
        stdlib.assert(v1482, {
          at: './donate.rsh:213:18:application',
          fs: ['at ./donate.rsh:212:9:application call to [unknown function] (defined at: ./donate.rsh:212:9:function exp)'],
          msg: null,
          who: 'Depositer'
          });
        const v1486 = stdlib.sub(v1440, v962);
        ;
        const v1487 = null;
        await txn4.getOutput('Bid_getBid', 'v1487', ctc3, v1487);
        const v1493 = stdlib.add(v963, stdlib.checkedBigNumberify('./donate.rsh:162:33:decimal', stdlib.UInt_max, 60));
        const cv962 = v1407;
        const cv963 = v1493;
        const cv964 = v1108;
        const cv965 = true;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v1486;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0_160': {
        const v1523 = v1109[1];
        const v1552 = v1523[stdlib.checkedBigNumberify('./donate.rsh:231:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1577 = stdlib.add(v974, v1552);
        ;
        undefined;
        const v1635 = stdlib.ge(v969, v963);
        const v1636 = stdlib.lt(v962, v919);
        const v1637 = v1635 ? v1636 : false;
        const v1638 = stdlib.ge(v1552, v919);
        const v1639 = v1637 ? v1638 : false;
        stdlib.assert(v1639, {
          at: './donate.rsh:239:18:application',
          fs: ['at ./donate.rsh:238:9:application call to [unknown function] (defined at: ./donate.rsh:238:9:function exp)'],
          msg: null,
          who: 'Depositer'
          });
        const v1643 = stdlib.sub(v1577, v962);
        ;
        const v1644 = null;
        await txn4.getOutput('Bid_getPurchase', 'v1644', ctc3, v1644);
        const cv962 = v1552;
        const cv963 = v963;
        const cv964 = v1108;
        const cv965 = false;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v1643;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_touch0_160': {
        const v1660 = v1109[1];
        ;
        ;
        undefined;
        const v1790 = null;
        await txn4.getOutput('Bid_touch', 'v1790', ctc3, v1790);
        const cv962 = v962;
        const cv963 = v963;
        const cv964 = v964;
        const cv965 = true;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v974;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      }
    
    }
  const v1797 = stdlib.add(v962, v921);
  const v1798 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1799 = stdlib.mul(v1798, v922);
  const v1800 = stdlib.add(v962, v1799);
  const v1801 = stdlib.gt(v1797, v1800);
  const v1802 = v1801 ? v1797 : v1800;
  const v1804 = stdlib.div(v974, stdlib.checkedBigNumberify('./donate.rsh:299:34:decimal', stdlib.UInt_max, 100));
  const v1805 = stdlib.mul(v918, v1804);
  const v1807 = stdlib.add(v1805, v1804);
  const v1808 = stdlib.sub(v974, v1807);
  const v1809 = stdlib.ge(v962, v919);
  const v1810 = stdlib.add(v1808, v1805);
  const v1811 = stdlib.add(v1810, v1804);
  const v1815 = stdlib.sub(v974, v1811);
  ;
  if (v1809) {
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 4,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1819, time: v1818, didSend: v833, from: v1817 } = txn4;
    ;
    const v1821 = stdlib.addressEq(v887, v1817);
    stdlib.assert(v1821, {
      at: './donate.rsh:335:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Depositer'
      });
    if (v1809) {
      const v1826 = stdlib.sub(v973, v973);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1875 = stdlib.sub(v973, v973);
    ;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 0,
      funcNum: 5,
      out_tys: [],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1879, time: v1878, didSend: v833, from: v1877 } = txn4;
    ;
    const v1881 = stdlib.addressEq(v887, v1877);
    stdlib.assert(v1881, {
      at: './donate.rsh:335:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Depositer'
      });
    if (v1809) {
      const v1886 = stdlib.sub(v1875, v1875);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
export async function Relay(ctcTop, interact) {
  if (typeof(ctcTop) !== 'object' || ctcTop._initialize === undefined) {
    return Promise.reject(new Error(`The backend for Relay expects to receive a contract as its first argument.`));}
  if (typeof(interact) !== 'object') {
    return Promise.reject(new Error(`The backend for Relay expects to receive an interact object as its second argument.`));}
  const ctc = ctcTop._initialize();
  const stdlib = ctc.stdlib;
  const ctc0 = stdlib.T_Address;
  const ctc1 = stdlib.T_UInt;
  const ctc2 = stdlib.T_Token;
  const ctc3 = stdlib.T_Null;
  const ctc4 = stdlib.T_Tuple([ctc3]);
  const ctc5 = stdlib.T_Tuple([ctc1]);
  const ctc6 = stdlib.T_Data({
    Bid_claim0_160: ctc4,
    Bid_close0_160: ctc4,
    Bid_getBid0_160: ctc5,
    Bid_getPurchase0_160: ctc5,
    Bid_touch0_160: ctc4
    });
  const ctc7 = stdlib.T_Bool;
  
  
  const txn1 = await (ctc.recv({
    didSend: false,
    evt_cnt: 4,
    funcNum: 0,
    out_tys: [ctc0, ctc0, ctc0, ctc0],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v880, v881, v882, v883], secs: v885, time: v884, didSend: v36, from: v879 } = txn1;
  ;
  const v887 = ctc.iam(v883);
  const txn2 = await (ctc.recv({
    didSend: false,
    evt_cnt: 14,
    funcNum: 1,
    out_tys: [ctc0, ctc0, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc1],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [v916, v917, v918, v919, v920, v921, v922, v923, v924, v925, v926, v927, v928, v929], secs: v931, time: v930, didSend: v89, from: v915 } = txn2;
  const v932 = stdlib.tokenEq(v925, v926);
  const v933 = v932 ? false : true;
  stdlib.assert(v933, {
    at: './donate.rsh:107:6:dot',
    fs: [],
    msg: 'non-network tokens distinct',
    who: 'Relay'
    });
  ;
  ;
  ;
  stdlib.assert(v933, {
    at: './donate.rsh:125:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v938 = stdlib.ge(v918, stdlib.checkedBigNumberify('./donate.rsh:126:27:decimal', stdlib.UInt_max, 0));
  const v939 = stdlib.le(v918, stdlib.checkedBigNumberify('./donate.rsh:126:48:decimal', stdlib.UInt_max, 99));
  const v940 = v938 ? v939 : false;
  stdlib.assert(v940, {
    at: './donate.rsh:126:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v941 = stdlib.ge(v920, stdlib.checkedBigNumberify('./donate.rsh:127:25:decimal', stdlib.UInt_max, 0));
  stdlib.assert(v941, {
    at: './donate.rsh:127:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v942 = stdlib.lt(v920, v919);
  stdlib.assert(v942, {
    at: './donate.rsh:128:10:application',
    fs: [],
    msg: null,
    who: 'Relay'
    });
  const v946 = stdlib.sub(stdlib.checkedBigNumberify('./donate.rsh:124:11:decimal', stdlib.UInt_max, 100000), stdlib.checkedBigNumberify('./donate.rsh:131:12:decimal', stdlib.UInt_max, 20000));
  ;
  const v950 = stdlib.sub(v946, stdlib.checkedBigNumberify('./donate.rsh:132:12:decimal', stdlib.UInt_max, 80000));
  ;
  const v951 = v915;
  const txn3 = await (ctc.recv({
    didSend: false,
    evt_cnt: 0,
    funcNum: 2,
    out_tys: [],
    timeoutAt: undefined,
    waitIfNotPresent: false
    }));
  const {data: [], secs: v954, time: v953, didSend: v114, from: v952 } = txn3;
  ;
  ;
  const v958 = stdlib.addressEq(v951, v952);
  stdlib.assert(v958, {
    at: './donate.rsh:138:6:dot',
    fs: [],
    msg: 'sender correct',
    who: 'Relay'
    });
  let v962 = stdlib.checkedBigNumberify('./donate.rsh:174:24:decimal', stdlib.UInt_max, 0);
  let v963 = v929;
  let v964 = v915;
  let v965 = true;
  let v966 = v953;
  let v969 = v954;
  let v972 = v950;
  let v973 = stdlib.checkedBigNumberify('./donate.rsh:138:15:decimal', stdlib.UInt_max, 1);
  let v974 = stdlib.checkedBigNumberify('./donate.rsh:107:6:dot', stdlib.UInt_max, 0);
  
  while (await (async () => {
    
    return v965;})()) {
    const v989 = stdlib.add(v962, v921);
    const v990 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
    const v991 = stdlib.mul(v990, v922);
    const v992 = stdlib.add(v962, v991);
    const v993 = stdlib.gt(v989, v992);
    const v994 = v993 ? v989 : v992;
    const txn4 = await (ctc.recv({
      didSend: false,
      evt_cnt: 1,
      funcNum: 6,
      out_tys: [ctc6],
      timeoutAt: undefined,
      waitIfNotPresent: false
      }));
    const {data: [v1109], secs: v1111, time: v1110, didSend: v705, from: v1108 } = txn4;
    switch (v1109[0]) {
      case 'Bid_claim0_160': {
        const v1112 = v1109[1];
        ;
        ;
        undefined;
        const v1169 = stdlib.addressEq(v1108, v916);
        const v1170 = stdlib.ge(v962, v919);
        const v1171 = v1169 ? v1170 : false;
        stdlib.assert(v1171, {
          at: './donate.rsh:263:18:application',
          fs: ['at ./donate.rsh:262:9:application call to [unknown function] (defined at: ./donate.rsh:262:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v1176 = stdlib.sub(v973, v973);
        ;
        const v1177 = null;
        await txn4.getOutput('Bid_claim', 'v1177', ctc3, v1177);
        const cv962 = v962;
        const cv963 = v963;
        const cv964 = v964;
        const cv965 = false;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v1176;
        const cv974 = v974;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_close0_160': {
        const v1249 = v1109[1];
        ;
        ;
        undefined;
        const v1323 = null;
        await txn4.getOutput('Bid_close', 'v1323', ctc3, v1323);
        const v1330 = stdlib.lt(v969, v963);
        const cv962 = v962;
        const cv963 = v963;
        const cv964 = v964;
        const cv965 = v1330;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v974;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_getBid0_160': {
        const v1386 = v1109[1];
        const v1407 = v1386[stdlib.checkedBigNumberify('./donate.rsh:206:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1440 = stdlib.add(v974, v1407);
        ;
        undefined;
        const v1472 = stdlib.lt(v969, v963);
        const v1479 = stdlib.ge(v1407, v994);
        const v1480 = v1472 ? v1479 : false;
        const v1481 = stdlib.ge(v1407, v920);
        const v1482 = v1480 ? v1481 : false;
        stdlib.assert(v1482, {
          at: './donate.rsh:213:18:application',
          fs: ['at ./donate.rsh:212:9:application call to [unknown function] (defined at: ./donate.rsh:212:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v1486 = stdlib.sub(v1440, v962);
        ;
        const v1487 = null;
        await txn4.getOutput('Bid_getBid', 'v1487', ctc3, v1487);
        const v1493 = stdlib.add(v963, stdlib.checkedBigNumberify('./donate.rsh:162:33:decimal', stdlib.UInt_max, 60));
        const cv962 = v1407;
        const cv963 = v1493;
        const cv964 = v1108;
        const cv965 = true;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v1486;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_getPurchase0_160': {
        const v1523 = v1109[1];
        const v1552 = v1523[stdlib.checkedBigNumberify('./donate.rsh:231:11:spread', stdlib.UInt_max, 0)];
        ;
        const v1577 = stdlib.add(v974, v1552);
        ;
        undefined;
        const v1635 = stdlib.ge(v969, v963);
        const v1636 = stdlib.lt(v962, v919);
        const v1637 = v1635 ? v1636 : false;
        const v1638 = stdlib.ge(v1552, v919);
        const v1639 = v1637 ? v1638 : false;
        stdlib.assert(v1639, {
          at: './donate.rsh:239:18:application',
          fs: ['at ./donate.rsh:238:9:application call to [unknown function] (defined at: ./donate.rsh:238:9:function exp)'],
          msg: null,
          who: 'Relay'
          });
        const v1643 = stdlib.sub(v1577, v962);
        ;
        const v1644 = null;
        await txn4.getOutput('Bid_getPurchase', 'v1644', ctc3, v1644);
        const cv962 = v1552;
        const cv963 = v963;
        const cv964 = v1108;
        const cv965 = false;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v1643;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      case 'Bid_touch0_160': {
        const v1660 = v1109[1];
        ;
        ;
        undefined;
        const v1790 = null;
        await txn4.getOutput('Bid_touch', 'v1790', ctc3, v1790);
        const cv962 = v962;
        const cv963 = v963;
        const cv964 = v964;
        const cv965 = true;
        const cv966 = v1110;
        const cv969 = v1111;
        const cv972 = v972;
        const cv973 = v973;
        const cv974 = v974;
        
        v962 = cv962;
        v963 = cv963;
        v964 = cv964;
        v965 = cv965;
        v966 = cv966;
        v969 = cv969;
        v972 = cv972;
        v973 = cv973;
        v974 = cv974;
        
        continue;
        break;
        }
      }
    
    }
  const v1797 = stdlib.add(v962, v921);
  const v1798 = stdlib.div(v962, stdlib.checkedBigNumberify('./donate.rsh:18:37:decimal', stdlib.UInt_max, 100));
  const v1799 = stdlib.mul(v1798, v922);
  const v1800 = stdlib.add(v962, v1799);
  const v1801 = stdlib.gt(v1797, v1800);
  const v1802 = v1801 ? v1797 : v1800;
  const v1804 = stdlib.div(v974, stdlib.checkedBigNumberify('./donate.rsh:299:34:decimal', stdlib.UInt_max, 100));
  const v1805 = stdlib.mul(v918, v1804);
  const v1807 = stdlib.add(v1805, v1804);
  const v1808 = stdlib.sub(v974, v1807);
  const v1809 = stdlib.ge(v962, v919);
  const v1810 = stdlib.add(v1808, v1805);
  const v1811 = stdlib.add(v1810, v1804);
  const v1815 = stdlib.sub(v974, v1811);
  ;
  if (v1809) {
    const txn4 = await (ctc.sendrecv({
      args: [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v973, v1802, v1809, v1815],
      evt_cnt: 0,
      funcNum: 4,
      lct: v966,
      onlyIf: true,
      out_tys: [],
      pay: [stdlib.checkedBigNumberify('./donate.rsh:335:7:decimal', stdlib.UInt_max, 0), []],
      sim_p: (async (txn4) => {
        const sim_r = { txns: [], mapRefs: [], maps: [] };
        
        const {data: [], secs: v1819, time: v1818, didSend: v833, from: v1817 } = txn4;
        
        sim_r.txns.push({
          amt: stdlib.checkedBigNumberify('./donate.rsh:335:7:decimal', stdlib.UInt_max, 0),
          kind: 'to',
          tok: undefined
          });
        const v1821 = stdlib.addressEq(v887, v1817);
        stdlib.assert(v1821, {
          at: './donate.rsh:335:7:dot',
          fs: [],
          msg: 'sender correct',
          who: 'Relay'
          });
        if (v1809) {
          const v1826 = stdlib.sub(v973, v973);
          sim_r.txns.push({
            amt: v973,
            kind: 'from',
            to: v883,
            tok: v925
            });
          sim_r.txns.push({
            amt: v972,
            kind: 'from',
            to: v881,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1826,
            kind: 'from',
            to: v881,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1815,
            kind: 'from',
            to: v881,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v926
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v925
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        else {
          sim_r.txns.push({
            amt: v972,
            kind: 'from',
            to: v881,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v973,
            kind: 'from',
            to: v881,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1815,
            kind: 'from',
            to: v881,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v926
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v925
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        return sim_r;
        }),
      soloSend: true,
      timeoutAt: undefined,
      tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc1, ctc7, ctc1],
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1819, time: v1818, didSend: v833, from: v1817 } = txn4;
    ;
    const v1821 = stdlib.addressEq(v887, v1817);
    stdlib.assert(v1821, {
      at: './donate.rsh:335:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Relay'
      });
    if (v1809) {
      const v1826 = stdlib.sub(v973, v973);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  else {
    const v1875 = stdlib.sub(v973, v973);
    ;
    const txn4 = await (ctc.sendrecv({
      args: [v881, v883, v887, v915, v916, v918, v919, v920, v925, v926, v962, v963, v964, v972, v1802, v1809, v1815, v1875],
      evt_cnt: 0,
      funcNum: 5,
      lct: v966,
      onlyIf: true,
      out_tys: [],
      pay: [stdlib.checkedBigNumberify('./donate.rsh:335:7:decimal', stdlib.UInt_max, 0), []],
      sim_p: (async (txn4) => {
        const sim_r = { txns: [], mapRefs: [], maps: [] };
        
        const {data: [], secs: v1879, time: v1878, didSend: v833, from: v1877 } = txn4;
        
        sim_r.txns.push({
          amt: stdlib.checkedBigNumberify('./donate.rsh:335:7:decimal', stdlib.UInt_max, 0),
          kind: 'to',
          tok: undefined
          });
        const v1881 = stdlib.addressEq(v887, v1877);
        stdlib.assert(v1881, {
          at: './donate.rsh:335:7:dot',
          fs: [],
          msg: 'sender correct',
          who: 'Relay'
          });
        if (v1809) {
          const v1886 = stdlib.sub(v1875, v1875);
          sim_r.txns.push({
            amt: v1875,
            kind: 'from',
            to: v883,
            tok: v925
            });
          sim_r.txns.push({
            amt: v972,
            kind: 'from',
            to: v881,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1886,
            kind: 'from',
            to: v881,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1815,
            kind: 'from',
            to: v881,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v926
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v925
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        else {
          sim_r.txns.push({
            amt: v972,
            kind: 'from',
            to: v881,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1875,
            kind: 'from',
            to: v881,
            tok: undefined
            });
          sim_r.txns.push({
            amt: v1815,
            kind: 'from',
            to: v881,
            tok: undefined
            });
          sim_r.txns.push({
            kind: 'halt',
            tok: v926
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: v925
            })
          sim_r.txns.push({
            kind: 'halt',
            tok: undefined
            })
          sim_r.isHalt = true;
          }
        return sim_r;
        }),
      soloSend: true,
      timeoutAt: undefined,
      tys: [ctc0, ctc0, ctc0, ctc0, ctc0, ctc1, ctc1, ctc1, ctc2, ctc2, ctc1, ctc1, ctc0, ctc1, ctc1, ctc7, ctc1, ctc1],
      waitIfNotPresent: false
      }));
    const {data: [], secs: v1879, time: v1878, didSend: v833, from: v1877 } = txn4;
    ;
    const v1881 = stdlib.addressEq(v887, v1877);
    stdlib.assert(v1881, {
      at: './donate.rsh:335:7:dot',
      fs: [],
      msg: 'sender correct',
      who: 'Relay'
      });
    if (v1809) {
      const v1886 = stdlib.sub(v1875, v1875);
      ;
      ;
      ;
      ;
      return;
      }
    else {
      ;
      ;
      ;
      return;
      }
    
    }
  
  
  
  
  
  };
const _ALGO = {
  appApproval: `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`,
  appClear: `BYEA`,
  extraPages: 1,
  mapDataKeys: 0,
  mapDataSize: 0,
  stateKeys: 3,
  stateSize: 304,
  unsupported: [],
  version: 8
  };
const _ETH = {
  ABI: `[
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v880",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v881",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v882",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v883",
                "type": "address"
              }
            ],
            "internalType": "struct T5",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T6",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "stateMutability": "payable",
    "type": "constructor"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "msg",
        "type": "uint256"
      }
    ],
    "name": "ReachError",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v880",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v881",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v882",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v883",
                "type": "address"
              }
            ],
            "internalType": "struct T5",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T6",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e0",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v916",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v917",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v918",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v919",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v920",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v921",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v922",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v923",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v924",
                "type": "uint256"
              },
              {
                "internalType": "address payable",
                "name": "v925",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v926",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v927",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v928",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v929",
                "type": "uint256"
              }
            ],
            "internalType": "struct T7",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T8",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e1",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e2",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e4",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "indexed": false,
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e5",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T16",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_claim0_160",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_close0_160",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getBid0_160",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getPurchase0_160",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_touch0_160",
                    "type": "tuple"
                  }
                ],
                "internalType": "struct T16",
                "name": "v1109",
                "type": "tuple"
              }
            ],
            "internalType": "struct T17",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "indexed": false,
        "internalType": "struct T18",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_e6",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1177",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1323",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1487",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1644",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": false,
        "internalType": "bool",
        "name": "v0",
        "type": "bool"
      }
    ],
    "name": "_reach_oe_v1790",
    "type": "event"
  },
  {
    "stateMutability": "payable",
    "type": "fallback"
  },
  {
    "inputs": [],
    "name": "Auction_bids",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_closed",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_closes",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_currentPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_endCTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_endSecs",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_highestBidder",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_lastCTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_minBid",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_owner",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_recvAddr",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_reservePrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_royalties",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_startPrice",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_token",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "Auction_tokenP",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_a0",
        "type": "bool"
      }
    ],
    "name": "Bid_claim",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_a0",
        "type": "bool"
      }
    ],
    "name": "Bid_close",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Bid_getBid",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "_a0",
        "type": "uint256"
      }
    ],
    "name": "Bid_getPurchase",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "bool",
        "name": "_a0",
        "type": "bool"
      }
    ],
    "name": "Bid_touch",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCreationTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentState",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      },
      {
        "internalType": "bytes",
        "name": "",
        "type": "bytes"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "_reachCurrentTime",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "internalType": "address payable",
                "name": "v916",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v917",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v918",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v919",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v920",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v921",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v922",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v923",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v924",
                "type": "uint256"
              },
              {
                "internalType": "address payable",
                "name": "v925",
                "type": "address"
              },
              {
                "internalType": "address payable",
                "name": "v926",
                "type": "address"
              },
              {
                "internalType": "uint256",
                "name": "v927",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v928",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "v929",
                "type": "uint256"
              }
            ],
            "internalType": "struct T7",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T8",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m1",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m2",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m4",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "internalType": "bool",
            "name": "msg",
            "type": "bool"
          }
        ],
        "internalType": "struct T13",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m5",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "components": [
          {
            "internalType": "uint256",
            "name": "time",
            "type": "uint256"
          },
          {
            "components": [
              {
                "components": [
                  {
                    "internalType": "enum _enum_T16",
                    "name": "which",
                    "type": "uint8"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_claim0_160",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_close0_160",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getBid0_160",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "uint256",
                        "name": "elem0",
                        "type": "uint256"
                      }
                    ],
                    "internalType": "struct T15",
                    "name": "_Bid_getPurchase0_160",
                    "type": "tuple"
                  },
                  {
                    "components": [
                      {
                        "internalType": "bool",
                        "name": "elem0",
                        "type": "bool"
                      }
                    ],
                    "internalType": "struct T14",
                    "name": "_Bid_touch0_160",
                    "type": "tuple"
                  }
                ],
                "internalType": "struct T16",
                "name": "v1109",
                "type": "tuple"
              }
            ],
            "internalType": "struct T17",
            "name": "msg",
            "type": "tuple"
          }
        ],
        "internalType": "struct T18",
        "name": "_a",
        "type": "tuple"
      }
    ],
    "name": "_reach_m6",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  },
  {
    "stateMutability": "payable",
    "type": "receive"
  }
]`,
  Bytecode: `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`,
  BytecodeLen: 31080,
  Which: `oD`,
  version: 6,
  views: {
    Auction: {
      bids: `Auction_bids`,
      closed: `Auction_closed`,
      closes: `Auction_closes`,
      currentPrice: `Auction_currentPrice`,
      endCTime: `Auction_endCTime`,
      endSecs: `Auction_endSecs`,
      highestBidder: `Auction_highestBidder`,
      lastCTime: `Auction_lastCTime`,
      minBid: `Auction_minBid`,
      owner: `Auction_owner`,
      recvAddr: `Auction_recvAddr`,
      reservePrice: `Auction_reservePrice`,
      royalties: `Auction_royalties`,
      startPrice: `Auction_startPrice`,
      token: `Auction_token`,
      tokenP: `Auction_tokenP`
      }
    }
  };
export const _Connectors = {
  ALGO: _ALGO,
  ETH: _ETH
  };
export const _Participants = {
  "Auctioneer": Auctioneer,
  "Bid_claim": Bid_claim,
  "Bid_close": Bid_close,
  "Bid_getBid": Bid_getBid,
  "Bid_getPurchase": Bid_getPurchase,
  "Bid_touch": Bid_touch,
  "Constructor": Constructor,
  "Depositer": Depositer,
  "Relay": Relay
  };
export const _APIs = {
  Bid: {
    claim: Bid_claim,
    close: Bid_close,
    getBid: Bid_getBid,
    getPurchase: Bid_getPurchase,
    touch: Bid_touch
    }
  };
